import { simpleAction } from 'src/ducks/utils';

import { ADD_MODAL, DELETE_MODAL, ModalAction, Modal } from './types';

export const pushModal = ({ type, props = {} }: Modal): ModalAction =>
  simpleAction(ADD_MODAL, { type, props });

export const removeModal = (modalId: string): ModalAction =>
  simpleAction(DELETE_MODAL, { modalId });
